'use strict';

import axios from 'axios';
import { createElement, appendElementContent } from '@jspartials/dom-api-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

// Selectors
const selector = {
  klarnaMessaging: '.js-klarna-messaging',
  inputPayments: 'product-details-payments'
};

// Elements
const element = {
  klarnaMessaging: document.querySelector(selector.klarnaMessaging) || null,
  inputPayments: document.getElementById(selector.inputPayments) || null
};

// Variables
let klarnaMessagingShowed = false;

const initKlarnaMessaging = () => {
  if (element.inputPayments) {
    listenDOMEvent(element.inputPayments, 'change', () => {
      if (element.inputPayments.checked && !klarnaMessagingShowed) {
        showKlarnaMessaging();
      }
    });
  }
};

const showKlarnaMessaging = () => {
  if (element.klarnaMessaging) {
    const url = element.klarnaMessaging.dataset.url;
    const amount = element.klarnaMessaging.dataset.amount;

    axios
      .post(url)
      .then((response) => {
        const klarnaScript = createKlarnaScript(
          response.data.scriptUrl,
          response.data.clientId
        );
        const klarnaElement = createKlarnaElement(
          response.data.key,
          response.data.locale,
          amount
        );

        element.klarnaMessaging.innerHTML = '';
        appendElementContent(element.klarnaMessaging, klarnaScript);
        appendElementContent(element.klarnaMessaging, klarnaElement);
        klarnaMessagingShowed = true;

        if (window.Klarna.OnsiteMessaging) {
          window.Klarna.OnsiteMessaging.refresh();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

const createKlarnaScript = (url, clientId) => {
  return createElement({
    tag: 'script',
    attributes: [
      {
        name: 'async',
        value: true
      },
      {
        name: 'src',
        value: url
      },
      {
        name: 'data-client-id',
        value: clientId
      }
    ]
  });
};

const createKlarnaElement = (key, locale, amount) => {
  return createElement({
    tag: 'klarna-placement',
    attributes: [
      {
        name: 'data-key',
        value: key
      },
      {
        name: 'data-locale',
        value: locale
      },
      {
        name: 'data-purchase-amount',
        value: amount
      }
    ]
  });
};

export { initKlarnaMessaging };
